module.exports = __webpack_public_path__ + "img/faceOne2One.0d1715d3.svg";